import { render, staticRenderFns } from "./JuradosTestigos.vue?vue&type=template&id=9b26ea68"
import script from "./JuradosTestigos.vue?vue&type=script&lang=js"
export * from "./JuradosTestigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports